import { LOGIN_SUCCESS } from '@quintoandar/bioma-auth/containers/constants';

import { USERS_ME_URL } from 'containers/App/constants';
import { refreshProfile } from '@quintoandar/bioma-auth/containers/actions';
import { loadProfileFromCache } from 'containers/App/actions';
import { isProfileCacheValid } from 'utils/cache';

const refreshProfileMiddleware = (store) => (next) => (action) => {
  if (action.type === LOGIN_SUCCESS) {
    if (isProfileCacheValid()) {
      store.dispatch(loadProfileFromCache());
    } else {
      store.dispatch(refreshProfile(USERS_ME_URL));
    }
  }
  return next(action);
};

export default refreshProfileMiddleware;
